import { Node } from 'reactflow'

// How far ourside of the node is allowed to trigger the closest node detection
import { DETECTION_DISTANCE_X, DETECTION_DISTANCE_Y } from '@ui/constants/pipelinesWorkflow'

type ClosestNodeResult = {
  distance: number
  node: Node | null
}

// taken from https://reactflow.dev/examples/nodes/proximity-connect
export const getClosestNode = (targetNode: Node, nodes: Node[]): Node | null => {
  const closestNode = nodes.reduce<ClosestNodeResult>(
    (res, n: Node) => {
      if (n.id !== targetNode.id && n.positionAbsolute && targetNode.positionAbsolute) {
        const dx = n.positionAbsolute.x - targetNode.positionAbsolute.x
        const dy = n.positionAbsolute.y - targetNode.positionAbsolute.y
        const d = Math.sqrt(dx * dx + dy * dy)

        if (d < res.distance && Math.abs(dx) < DETECTION_DISTANCE_X && Math.abs(dy) < DETECTION_DISTANCE_Y) {
          res.distance = d
          res.node = n
        }
      }

      return res
    },
    {
      distance: Number.MAX_VALUE,
      node: null,
    }
  )

  if (!closestNode.node) {
    return null
  }

  return closestNode.node
}
